import React from 'react'

const EmptyMarginBlock = () => {
  return <div className="lg:py-10 md:py-7 py-4" />
}

export default React.memo(EmptyMarginBlock)
